import { Plus } from "lucide-react";
import { FAQ } from "./content";

export function Faq(): JSX.Element {
  return (
    <section id="faq" aria-labelledby="faq-heading" className="scroll-mt-20 border-t border-border">
      <div className="mx-auto grid max-w-[77.5rem] gap-10 px-4 py-24 sm:px-6 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-20 lg:px-8">
        <h2
          id="faq-heading"
          className="max-w-[14ch] self-start text-[clamp(2rem,1.4rem+2.2vw,3.25rem)] font-bold leading-[1.05] tracking-[-0.035em] lg:sticky lg:top-28"
        >
          Perguntas que sempre aparecem.
        </h2>

        <div className="border-t border-border-strong">
          {FAQ.map((item) => (
            <details key={item.q} className="lp-faq group border-b border-border">
              <summary className="flex cursor-pointer items-start justify-between gap-6 py-5 text-left text-[1.0625rem] font-medium leading-snug transition-colors hover:text-signal">
                {item.q}
                <Plus size={20} className="lp-faq-icon mt-0.5 shrink-0 text-muted-foreground" aria-hidden="true" />
              </summary>
              <p className="lp-faq-body max-w-[62ch] pb-6 pr-10 text-[0.9375rem] leading-relaxed text-muted-foreground">
                {item.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
